import Swiper, {Pagination} from "swiper";
import 'swiper/css/bundle';

Swiper.use( [Pagination] )

class PostsSlider {
	constructor(el) {
		this.el         = el
		this.swiperEl   = el.querySelector( '.swiper' )
		this.pagination = el.querySelector( '.posts-slider__pagination' )

		this.init()
	}

	init() {
		const options = {
			// loop: true,
			grabCursor: true,
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			spaceBetween: 16,
			centeredSlides: true,
			centeredSlidesBounds: true,
			pagination: {
				el: this.pagination,
				type: 'bullets',
				clickable: true
			},
			breakpoints: {
				1: {
					slidesPerGroup: 1,
				},
				576: {
					slidesPerGroup: 2,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 'auto',
					slidesPerGroup: 2,
					spaceBetween: 30,
					centeredSlides: true,
					centeredSlidesBounds: true,
				},
				992: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 30,
					centeredSlides: false,
					centeredSlidesBounds: false,
				}
			},
			on: {
				beforeTransitionStart: function (swiper) {
					const index = swiper.snapIndex
					if (index !== 0 && index * 2 < (swiper.slides.length - 1) && window.matchMedia( '(min-width: 576px) and (max-width: 992px)' ).matches) {
						let translate = 0
						if (index * 2 >= swiper.slides.length - 2) {
							  translate = swiper.snapGrid[index] + ((swiper.slidesSizesGrid[index] + swiper.params.spaceBetween) / 2) - swiper.params.spaceBetween
						} else {
							  translate = swiper.snapGrid[index] + ((swiper.slidesSizesGrid[index] + swiper.params.spaceBetween) / 2)
						}
						swiper.setTranslate( -translate )
					}
				}
			},
		};
		this.Swiper = new Swiper( this.swiperEl, options )
	}

}

(() => {
	Array.from( document.querySelectorAll( '.posts-slider' ) ).forEach( item => new PostsSlider( item ) )
})()
